var render = function render(){var _vm=this,_c=_vm._self._c;return _c('side-bar',{attrs:{"title":"Administration","short-title":"Admin","items":_vm.sidebarItems},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }